// extracted by mini-css-extract-plugin
export default {"courseType":"CourseBadge_courseType__QKgrS","professional":"CourseBadge_professional__F3LsO","masterclass":"CourseBadge_masterclass__-llMF"};